export default "__VITE_ASSET__ChL4IBv9__"